import { useMutation } from "@apollo/client";
import { BULK_UPLOAD_ASSETS } from "../../graphql/mutations/assets/assets.mutations";

const useBulkUploadAssets = () => {
  const [bulkUploadAssetsMutation, { loading, error }] =
    useMutation(BULK_UPLOAD_ASSETS);

  const bulkUploadAssets = async (assets) => {
    try {
      const res = await bulkUploadAssetsMutation({ variables: { assets } });
      return res?.data?.bulkUploadAssets ?? { created: [], failed: [] };
    } catch (err) {
      console.error(`Error uploading assets: ${err?.message}`);
      throw err;
    }
  };

  return { bulkUploadAssets, loading, error };
};

export default useBulkUploadAssets;
